export const APP_URL_PREFIX = '/personal/insure/travel-insurance';

export const PAGE_INDICES = {
    LANDING_PAGE: -1,
    QOUTE: 0,
    SELECT_PLAN: 1,
    CONFIRM_DETAILS: 2,
    TRAVELER_DETAILS: 3,
    PAYMENT: 4,
};

export const PAGES = [
    {
        URL: `${APP_URL_PREFIX}/get-quote`,
        URL_PART: 'get-quote',
        TITLE: 'Get Quote',
    },
    {
        URL: `${APP_URL_PREFIX}/select-plan`,
        URL_PART: 'select-plan',
        TITLE: 'Select Plan',
    },
    {
        URL: `${APP_URL_PREFIX}/confirm-details`,
        URL_PART: 'confirm-details',
        TITLE: 'Confirm Details',
    },
    {
        URL: `${APP_URL_PREFIX}/traveler-details`,
        URL_PART: 'confirm-details',
        TITLE: 'Confirm Details',
    },
    {
        URL: `${APP_URL_PREFIX}/payment`,
        URL_PART: 'payment',
        TITLE: 'Payment',
    },
];

export const COVER_PLANS = {
    RETAIL: { title: 'Retail', value: 'retail' },
    STUDENT_COVER: { title: 'Student Cover', value: 'student' },
    PILGRIMAGE: { title: 'Pilgrimage', value: 'pilgrimage' },
};

export const TOGGLE_STATUS = {
    YES: true,
    NO: false,
    UNTOUCHED: 'untouched',
};

export const TRAVEL_KE_URLS = {
    QOUTE: PAGES[PAGE_INDICES.QOUTE].URL,
    SELECT_PLAN: PAGES[PAGE_INDICES.SELECT_PLAN].URL,
    CONFIRM_DETAILS: PAGES[PAGE_INDICES.CONFIRM_DETAILS].URL,
    TRAVELER_DETAILS: PAGES[PAGE_INDICES.TRAVELER_DETAILS].URL,
    PAYMENT: PAGES[PAGE_INDICES.PAYMENT].URL,
};
